export function createEnumChecker<T extends string, EnumValue extends string>(enumVariable: {
  [key in T]: EnumValue;
}) {
  const enumValues = Object.values(enumVariable);
  return (value: string): value is EnumValue => enumValues.includes(value);
}
